<template>
  <div class="p-3 row">
    <div class="col-12 col-xl-7 min-h-100">
      <el-form :model="form" :rules="rules" ref="form" @submit.prevent.native="onSubmit">
        <div class="row mb-3">
          <h4 class="col-7">Максимально допустимое количество точек изображения по ширине или высоте</h4>
          <el-form-item class="col-5" prop="maxSizePx">
            <el-input v-model="form.maxSizePx" @input="form.maxSizePx = replaceNumber($event)" placeholder="Например: 2048"/>
          </el-form-item>
        </div>
        <div class="row mb-3">
          <h4 class="col-7">Качество изображения в процентах</h4>
          <el-form-item class="col-5" prop="quality">
            <el-input v-model="form.quality" @input="form.quality = replaceNumber($event)" placeholder="Например: 20"/>
          </el-form-item>
        </div>
        <div class="row">
          <h4 class="col-7">Форматы изображений для компрессии</h4>
          <el-form-item class="col-5" prop="allowedTypes">
            <div class="border types-container py-2 px-3">
              <el-tag v-for="(type, ind) in form.allowedTypes" :key="ind" closable :disable-transitions="false" @close="onDeleteImageType(type)">
                {{replaceTypeText(type)}}
              </el-tag>
              <div class="d-flex w-100">
                <el-input v-model="imageTypeInputValue" class="mr-1" ref="saveImageTypeInput" @input="imageTypeInputValue = replaceImageType($event)"
                          size="mini" placeholder="Например: jpg" @keyup.enter.native="handleInputConfirm">
                </el-input>
                <el-button icon="el-icon-check" size="mini" circle @click="handleInputConfirm"
                           :disabled="!isValidImageTypeValue" />
              </div>
            </div>
          </el-form-item>
        </div>
      </el-form>
      <div class="d-flex justify-content-end mt-3">
        <el-button type="primary" size="medium" :loading="updateImageSettingsProgress" :disabled="allProgress" @click="onSubmit">
          Сохранить
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { MESSAGES } from '@/commons/constants/errorMessages';
import { replaceNumber } from '@/commons/helpers';

export default {
  name: 'ImageSaveSettingsForm',
  data() {
    const qualityValidator = (rule, value, callback) => {
      if (parseInt(this.form.quality, 10) < 1 || parseInt(this.form.quality, 10) > 100) {
        return callback(new Error(MESSAGES.MIN_MAX_VALUE(1, 100)));
      }
      return callback();
    };
    return {
      isEdited: false,
      form: {
        maxSizePx: null,
        quality: null,
        allowedTypes: [],
      },
      imageTypeInputValue: '',
      rules: {
        maxSizePx: [
          { min: 1, message: MESSAGES.MIN_LENGTH(1), trigger: 'blur' },
          { max: 4, message: MESSAGES.MAX_LENGTH(4), trigger: 'blur' },
          { required: true, message: MESSAGES.REQUIRED, trigger: 'blur' },
        ],
        quality: [
          { required: true, message: MESSAGES.REQUIRED, trigger: 'blur' },
          { validator: qualityValidator, trigger: 'blur' },
        ],
        allowedTypes: [
          { required: true, message: MESSAGES.REQUIRED, trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      fetchImageSettingsProgress: 'settings/fetchImageSettingsProgress',
      updateImageSettingsProgress: 'settings/updateImageSettingsProgress',
      imageSettings: 'settings/imageSettings',
    }),
    allProgress() {
      return this.fetchImageSettingsProgress || this.updateImageSettingsProgress;
    },
    isValidImageTypeValue() {
      return !this.form.allowedTypes.includes(this.imageTypeInputValue);
    },
  },
  methods: {
    ...mapActions({
      fetchImageSettings: 'settings/fetchImageSettings',
      updateImageSettings: 'settings/updateImageSettings',
    }),
    replaceTypeText(text) {
      return text.length > 12 ? `${text.substr(0, 12)}...` : text;
    },
    replaceNumber,
    replaceImageType(str) {
      return str.replace(/[^a-z0-9]/i, '');
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const data = {
            ...this.form,
          };
          this.updateImageSettings({ data });
          this.isEdited = false;
        }
      });
    },

    onDeleteImageType(type) {
      this.form.allowedTypes.splice(this.form.allowedTypes.indexOf(type), 1);
    },

    showInput() {
      this.$nextTick(() => {
        this.$refs.saveImageTypeInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      if (this.isValidImageTypeValue) {
        if (this.imageTypeInputValue) {
          this.form.allowedTypes.push(this.imageTypeInputValue);
        }
        this.imageTypeInputValue = '';
      }
    },
    fillForm() {
      if (this.imageSettings) {
        this.form.maxSizePx = this.imageSettings.maxSizePx?.toString();
        this.form.quality = this.imageSettings.quality?.toString();
        this.form.allowedTypes = [...this.imageSettings.allowedTypes];
      } else {
        this.form.maxSizePx = null;
        this.form.quality = null;
        this.form.allowedTypes = [];
      }
    },
  },
  watch: {
    imageSettings() {
      this.fillForm();
    },
  },
  created() {
    this.fetchImageSettings();
  },
};
</script>

<style scoped lang="scss">
h4 {
  font-weight: 500;
  font-size: 14px;
}
.types-container {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: flex-start;
}
.button-new-image-type {
  font-size: 20px;
  padding: 0;
  align-items: center;
  height: 32px;
  width: 32px;
}
</style>
